import {
    setSliceRatio,
    setSliceQuality,
    setSliceDuration,
    setSliceTabIndex,
    setSliceTVTextValue,
    setSliceIVTextValue,
    setSliceOriginImage,
    setSliceUploadStatus,
    setSliceInspireList,
    setSlicePresetList,
    setSliceCurrentTackId,
    setSliceCurrentGenerateStatus,
    setSliceGeneratingVideoNum,
    setSliceIsShowGeneratingVideoNum,
    setSliceIVFreeNumCreationAction,
    setSliceTVFreeNumCreationAction,
    setSliceSortType,
} from '../slices/FJSliceAIVideoGenerator';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJUtil from '../../util/FJUtil.js';
import FJCompressedImageStore from '../../store/FJCompressedImageStore.js';
import FJConstant from '../../constants/FJConstant.js';
import FJConfig from '../../config/FJConfig';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJActionCommon from './FJActionCommon.js';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import {
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceTaskStatusAction,
} from '../slices/FJSliceCommon.js';
import { UPLOAD_FILE_TO_VIDEO } from '../../config/dataConfig/FJGenerateData';
import FJImageStore from '../../store/FJImageStore.js';
import FJActionModal from './FJActionModal.js';
import FJAIVideoGeneratorData from '../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore.js';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJStringUtil from '../../util/FJStringUtil.js';
import FJHeaderConfig from '../../config/FJHeaderConfig.js';

let f_isFirstShowGeneratingVideoNum = false;
let f_timer = null;
let f_errorTime = 0;
let f_isPolling = false;

const FJActionAIVideoGenerator = {
    setSortTypeAction: function (type) {
        return dispatch => {
            dispatch(setSliceSortType(type));
        };
    },
    changeRatioAction: function (ratio) {
        return dispatch => {
            dispatch(setSliceRatio(ratio));
        };
    },

    changeQualityAction: function (quality) {
        return dispatch => {
            dispatch(setSliceQuality(quality));
        };
    },

    changeDurationAction: function (duration) {
        return dispatch => {
            dispatch(setSliceDuration(duration));
        };
    },

    changeTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceTabIndex(index));
        };
    },

    changeTextValueAction: function (value) {
        return (dispatch, getState) => {
            const tabIndex = getState().AIVideoGenerator.tabIndex;
            if (tabIndex === 0) {
                dispatch(setSliceTVTextValue(value));
            } else {
                dispatch(setSliceIVTextValue(value));
            }
        };
    },

    changeOriginImageInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceOriginImage({ ...info }));
        };
    },

    changeUploadStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceUploadStatus(status));
        };
    },

    clearFileAction: function () {
        return dispatch => {
            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
            dispatch(this.changeOriginImageInfoAction({}));
        };
    },

    uploadFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIVideoGenerator.uploadStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            };
            const isImage = FJUtil.isImage(file, undefined, UPLOAD_FILE_TO_VIDEO);

            if (isImage) {
                dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                let isImageExceedSize = false;
                try {
                    isImageExceedSize = await FJUtil.checkImageSize(file);
                    if (isImageExceedSize) {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-image'), 'error');
                        dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        return;
                    }
                } catch (e) {
                    __fileError();
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }

                const data = await FJCompressedImageStore.compressImageByFile(file, { maxPixel: 1000 });
                if (data) {
                    dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
                    dispatch(this.changeOriginImageInfoAction({ ...data, type: 'local', source: FJConstant.LOCAL }));
                } else {
                    __fileError();
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                }
            } else {
                __fileError();
            }
        };
    },

    initAIVideoGeneratorAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const {
                    generationType,
                    prompt,
                    ratio = '16:9',
                    duration = 5,
                    modelType,
                    imageUrl,
                    source,
                    fileList,
                    avator,
                } = recIdInfo;
                if (fileList) {
                    // 一定是图生视频
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.changeTabIndexAction(1));
                    dispatch(this.uploadFileAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    const fileName = FJUtil.getFileName(avator);
                    const file = new File([blob], fileName, { type: 'image/png' });
                    dispatch(this.changeTabIndexAction(1));
                    dispatch(this.uploadFileAction(file));
                } else {
                    const tabIndex = generationType === 'tv' ? 0 : 1;
                    dispatch(this.changeTabIndexAction(tabIndex));
                    dispatch(this.changeRatioAction(ratio));
                    dispatch(this.changeDurationAction(duration));
                    dispatch(this.changeQualityAction(modelType === 'standard' ? 1 : 2));
                    if (tabIndex === 0) {
                        dispatch(setSliceTVTextValue(prompt));
                    } else {
                        dispatch(setSliceIVTextValue(prompt));
                        dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
                        dispatch(this.changeOriginImageInfoAction({ src: imageUrl, source }));
                    }
                }
            }
            const tabType = FJUtil.getQueryString('tab_type');
            if (tabType) {
                const tabIndex = tabType === 'tv' ? 0 : 1;
                dispatch(this.changeTabIndexAction(tabIndex));
            }
            dispatch(this._initInspireListAction());
            dispatch(this._initPresetAIVideoAction());
        };
    },

    retryTaskAction: function (id) {
        return async (dispatch, getState) => {
            const state = getState();
            const historyList = state.common.historyList;
            const itemInfo = historyList.find(item => item.status === 'failed' && item.id === id);
            if (itemInfo) {
                const { generationType, aspectRatio, duration, modelType, originalUrl, source, prompt } = itemInfo;

                const tabIndex = generationType === 'tv' ? 0 : 1;

                dispatch(this.changeTabIndexAction(tabIndex));
                dispatch(this.changeRatioAction(aspectRatio));
                dispatch(this.changeDurationAction(duration));
                dispatch(this.changeQualityAction(modelType === 'standard' ? 1 : 2));
                if (tabIndex === 0) {
                    dispatch(setSliceTVTextValue(prompt));
                } else {
                    dispatch(setSliceIVTextValue(prompt));
                    dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
                    dispatch(this.changeOriginImageInfoAction({ src: originalUrl, source }));
                }
                dispatch(FJActionCommon.setHeaderTabIndexAction(0));

                // const data = {
                //     originImage: { src: originalUrl, source },
                //     generationType,
                //     modelType,
                //     prompt,
                //     duration,
                //     ratio: aspectRatio,
                //     totalCredit: 0,
                //     tabIndex,
                // };
                // dispatch(this._onGenerateAction(data));
            }
        };
    },

    /**
     * 初始化灵感列表
     * @returns
     */
    _initInspireListAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.inspireListJsonPath);
            const inspireList = await response.json();
            dispatch(setSliceInspireList(inspireList));
        };
    },

    _initPresetAIVideoAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.presetListJsonPath);
            const { tvList, ivList } = await response.json();

            const getRandomIndexes = (length, count) => {
                const indexes = [];
                while (indexes.length < count) {
                    const randomIndex = Math.floor(Math.random() * length);
                    if (!indexes.includes(randomIndex)) {
                        indexes.push(randomIndex);
                    }
                }
                return indexes;
            };

            const allCount = 3;

            const imgVideoCount = Math.random() < 0.5 ? 2 : 1;
            const textVideoCount = allCount - imgVideoCount;

            const randomImgVideoIndexes = getRandomIndexes(ivList.length, imgVideoCount);
            const randomTextVideoIndexes = getRandomIndexes(tvList.length, textVideoCount);

            const curImgVideoPresetList = randomImgVideoIndexes.map(index => {
                return {
                    imageUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${ivList[index].imageUrl}`.replace(
                        '.webp',
                        '.png',
                    ),
                    videoUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${ivList[index].videoUrl}`,
                    smallImageUrl:
                        `${FJConfig.serverPath}${FJConfig.presetPreviewPath}small/${ivList[index].imageUrl}`.replace(
                            '.webp',
                            '.png',
                        ),
                    prompt: ivList[index].prompt,
                    type: 'image',
                };
            });

            const curTextVideoPresetList = randomTextVideoIndexes.map(index => {
                return {
                    imageUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${tvList[index].imageUrl}`.replace(
                        '.webp',
                        '.png',
                    ),
                    videoUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${tvList[index].videoUrl}`,
                    prompt: tvList[index].prompt,
                    type: 'text',
                };
            });

            const curList =
                imgVideoCount === 2
                    ? [...curImgVideoPresetList, ...curTextVideoPresetList]
                    : [...curTextVideoPresetList, ...curImgVideoPresetList];

            dispatch(setSlicePresetList([...curList]));
        };
    },

    getInspireAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const inspireList = state.AIVideoGenerator.inspireList;

            if (!inspireList) {
                return;
            }

            const curLang = FJLocalStore.currentTag();
            const inspireListByLang = inspireList[curLang] || inspireList['en'];
            const curPrompt = getState().AIVideoGenerator.prompt;

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireListByLang.length);

                if (inspireListByLang[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireListByLang[randomIndex];
            };

            let prompt = __getRandomInspire();

            dispatch(this.changeTextValueAction(prompt));
        };
    },

    onClickUsePromptAction: function (info) {
        return async dispatch => {
            const { imageUrl, prompt, type } = info;
            dispatch(this.changeTabIndexAction(type === 'text' ? 0 : 1));

            if (type === 'image') {
                dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                const isImageExceedSize = await FJUtil.checkImageSize(imageUrl);
                if (isImageExceedSize) {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-image'), 'error');
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }

                dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
                dispatch(this.changeOriginImageInfoAction({ src: imageUrl, source: FJConstant.AI_VIDEO_FLEXCLIP }));
                prompt && dispatch(setSliceIVTextValue(prompt));
            } else {
                prompt && dispatch(setSliceTVTextValue(prompt));
            }
        };
    },

    setCurrentGenerateStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceCurrentGenerateStatus(status));
        };
    },

    setCurrentTackIdAction: function (id) {
        return dispatch => {
            dispatch(setSliceCurrentTackId(id));
        };
    },

    setGeneratingVideoNumAction: function (num) {
        return dispatch => {
            dispatch(setSliceGeneratingVideoNum(num));
        };
    },

    setIsShowGeneratingVideoNumAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsShowGeneratingVideoNum(bool));
        };
    },

    useAIImageAction: function (info, curMenuIndex) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIVideoGenerator.uploadStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }

            const source = curMenuIndex === 0 ? FJConstant.AI_VIDEO_TEXT_IMAGE_S3 : FJConstant.AI_VIDEO_IMAGE_IMAGE_S3;
            dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
            const isImageExceedSize = await FJUtil.checkImageSize(info.imgUrl);
            if (isImageExceedSize) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-image'), 'error');
                dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                return;
            }

            dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.changeOriginImageInfoAction({
                    src: info.imgUrl,
                    source: source,
                }),
            );
        };
    },

    onGenerateAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const tabIndex = state.AIVideoGenerator.tabIndex;
            const currentRatio = state.AIVideoGenerator.currentRatio;
            const currentQuality = state.AIVideoGenerator.currentQuality;
            const currentDuration = state.AIVideoGenerator.currentDuration;
            const originImage = state.AIVideoGenerator.originImage;
            const tvTextValue = state.AIVideoGenerator.tvTextValue;
            const ivTextValue = state.AIVideoGenerator.ivTextValue;
            const totalCredit = state.AIVideoGenerator.totalCredit;
            const audioActive = state.AIVideoGenerator.audioActive;
            const aiSfxTotalCredit = state.AIVideoGenerator.aiSfxTotalCredit;

            const data = {
                originImage: originImage,
                generationType: tabIndex === 0 ? 'tv' : 'iv',
                modelType: currentQuality === 1 ? 'standard' : 'v1.5',
                prompt: tabIndex === 0 ? tvTextValue : ivTextValue,
                duration: currentDuration,
                ratio: currentRatio,
                totalCredit: totalCredit + aiSfxTotalCredit,
                tabIndex,
                audioActive,
            };

            dispatch(this._onGenerateAction(data));
        };
    },

    _onGenerateAction: function (data) {
        return async (dispatch, getState) => {
            const state = getState();
            const {
                originImage,
                generationType,
                modelType,
                prompt,
                duration,
                ratio,
                totalCredit,
                tabIndex,
                audioActive,
            } = data;

            const creditNumber = state.common.creditNumber;
            const { ivFreeNum, tvFreeNum } = state.AIVideoGenerator;
            const freeNumCreation = tabIndex === 1 ? ivFreeNum : tvFreeNum;
            let waterfallRatio = 0;
            let source = tabIndex === 0 ? 0 : originImage?.source;
            // ab测试统计
            const abTest = window?.fjuser?.info?.id % 2 === 0 ? 'text to video' : 'image to video';
            FJUtil.eaLog('ai videos generate click', {
                mode: modelType === 'standard' ? 'standard' : 'professional',
                ratio: ratio,
                duration: duration,
                type: tabIndex === 0 ? 'text to video' : 'image to video',
                ABtest: abTest,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(0));

            dispatch(setSliceTaskStatusAction(FJConstant.START));

            // 判断是否需要上传图片到s3
            let imgUrl = originImage?.src;
            let audioPrompt = '';

            if (tabIndex === 1) {
                if (!imgUrl) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        dispatch(this.generateErrorAction(true));
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }

                if (totalCredit > creditNumber && (freeNumCreation === 0 || totalCredit > 11.5)) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }

                try {
                    if (originImage.type === 'local') {
                        const file = await FJUtil.getBlobByUrl(imgUrl);
                        const id = await FJUtil.hashEncode(file);
                        const key = FJConfig.originalImageKey + `${id}.png`;
                        const result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (result) {
                            imgUrl = FJS3Config.S3_SERVER_HOST + key;
                        } else {
                            dispatch(this.generateErrorAction(true));
                            return;
                        }
                        source = 1;
                    }
                    try {
                        waterfallRatio = await FJImageStore.getImageRatio(imgUrl);
                    } catch (e) {
                        waterfallRatio = await FJImageStore.getImageRatio(imgUrl + `?v=${new Date().getTime()}`);
                    }

                    if (audioActive) {
                        const simpleImageUrl = await FJImageStore.upLoadFileToS3ByUrl(imgUrl, {
                            isCompress: true,
                            maxWidth: 400,
                            maxHeight: 400,
                        });
                        const { data, code } = await FJNetworkStore.generateImageByPromptInAiSfx(simpleImageUrl, 'en');
                        if (code === 200) {
                            audioPrompt = data.prompt;
                        }
                    }
                } catch (e) {
                    dispatch(this.generateErrorAction(true));
                    return;
                }
            } else {
                waterfallRatio = FJAIVideoGeneratorData.RATIO_LIST.find(item => item.name === ratio).value;
                imgUrl = null;
                const _prompt = prompt.replace(/\s/g, '');
                if (_prompt.length === 0 || prompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        dispatch(this.generateErrorAction(true));
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                if (totalCredit > creditNumber && (freeNumCreation === 0 || totalCredit > 10)) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }

                if (audioActive) {
                    try {
                        audioPrompt = await FJStringUtil.translatePrompt(prompt);
                    } catch (e) {
                        dispatch(this.generateErrorAction(true));
                        return;
                    }
                }
            }

            const tool = FJUtil.getToolName();
            const canFreeCreate = freeNumCreation > 0;
            const isFree = creditNumber < totalCredit && canFreeCreate;
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

            // AI生成视频
            const _request = async () => {
                return await FJNetworkStore.videoGeneration({
                    imageUrl: imgUrl,
                    generationType,
                    modelType,
                    prompt,
                    duration,
                    ratio,
                    waterfallRatio,
                    source,
                    audioActive,
                    audioPrompt,
                });
            };
            try {
                const currentTaskId = await FJActionCommon.createRequestTask(_request, dispatch);
                FJUtil.updateAllCreditInfo(isFree);

                dispatch(this.setCurrentGenerateStatusAction(FJConstant.RUNNING));
                dispatch(this.setCurrentTackIdAction(currentTaskId));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionCommon.updateHistoryListAction());
            } catch (e) {
                dispatch(this.generateErrorAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    checkIsShowGeneratingVideoNumAction: function () {
        return (dispatch, getState) => {
            const state = getState();
            const currentTackId = state.AIVideoGenerator.currentTackId;
            const historyList = state.common.historyList;
            const generatingTaskIdList = historyList
                .filter(item => item.status === 'progress')
                .map(item => item.eventId);
            const generatingVideoNum = generatingTaskIdList.length;

            if (currentTackId) {
                const item = historyList.find(item => item.eventId === currentTackId);
                if (item.status === 'completed') {
                    dispatch(this.setCurrentGenerateStatusAction(FJAppConstant.SUCCESS));
                    dispatch(
                        setSliceCreationListAction([
                            {
                                originalImageUrl: item.originalUrl,
                                videoUrl: item.videoUrl,
                                coverImageUrl: item.imgUrl,
                                id: item.id,
                                ratio: item.ratio,
                            },
                        ]),
                    );
                    dispatch(this.setCurrentTackIdAction(null));
                } else if (item.status === 'failed') {
                    dispatch(this.generateErrorAction());
                } else {
                    dispatch(this.setCurrentGenerateStatusAction(FJAppConstant.RUNNING));
                }
            }

            dispatch(this.setGeneratingVideoNumAction(generatingVideoNum));
            if (!f_isPolling) {
                dispatch(this.pollingVideoGeneratorTaskListAction());
            }

            // 是否首次显示
            if (!f_isFirstShowGeneratingVideoNum) {
                if (currentTackId) {
                    if (generatingTaskIdList.indexOf(currentTackId) !== -1 && generatingVideoNum > 1) {
                        dispatch(this.setIsShowGeneratingVideoNumAction(true));
                        f_isFirstShowGeneratingVideoNum = true;
                    }
                } else {
                    if (generatingVideoNum > 0) {
                        dispatch(this.setIsShowGeneratingVideoNumAction(true));
                        f_isFirstShowGeneratingVideoNum = true;
                    }
                }
            }
        };
    },

    pollingVideoGeneratorTaskListAction: function () {
        return async (dispatch, getState) => {
            f_isPolling = true;
            const _clear = () => {
                f_isPolling = false;
                if (f_timer) {
                    clearTimeout(f_timer);
                    f_timer = null;
                }
            };
            _clear();
            const state = getState();
            const historyList = state.common.historyList;

            const generatingTaskIdList = historyList
                .filter(item => item.status === 'progress')
                .map(item => item.eventId);
            if (generatingTaskIdList.length === 0) {
                dispatch(this.setGeneratingVideoNumAction(0));
                dispatch(this.setIsShowGeneratingVideoNumAction(false));
                _clear();
                return;
            }

            const delayTime = TASK_POLLING_INTERVAL * 30;
            const __pollingFunc = () => {
                dispatch(this.pollingVideoGeneratorTaskListAction());
            };

            try {
                const result = await FJNetworkStore.getTaskState(generatingTaskIdList.join(','));
                let isStopPolling = false;
                let data = result;

                if (!data) {
                    f_errorTime++;
                    if (f_errorTime >= MAX_POLLING_ERROR_TIME) {
                        _clear();
                    } else {
                        _clear();
                        f_isPolling = true;
                        f_timer = setTimeout(__pollingFunc, delayTime);
                    }
                    return;
                }

                if (!Array.isArray(result)) {
                    // 处理数组类型的data
                    data = [result];
                }

                let failTaskCount = 0;
                let isNeedUpdate = false;
                await Promise.all(
                    data.map(async item => {
                        switch (item.job_state) {
                            case 'succeeded':
                                try {
                                    if (item.out_put) {
                                        const {
                                            aspect_ratio,
                                            model_type,
                                            prompt,
                                            duration,
                                            generation_type,
                                            is_dubbing,
                                        } = item.out_put[0].request_params;
                                        // ab测试统计
                                        const abTest =
                                            window?.fjuser?.info?.id % 2 === 0 ? 'text to video' : 'image to video';
                                        FJUtil.eaLog('ai videos generate success', {
                                            mode: model_type === 'standard' ? 'standard' : 'professional',
                                            ratio: aspect_ratio,
                                            duration: duration,
                                            type: generation_type === 'tv' ? 'text to video' : 'image to video',
                                            prompt: prompt,
                                            ABtest: abTest,
                                            'ai sfx': is_dubbing ? 'true' : 'false',
                                        });

                                        const info = JSON.parse(item.out_put[0].info);

                                        if (is_dubbing && !info.has_dubbing) {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('dubbing-failed-please-try-again'),
                                                'error',
                                            );
                                            FJUtil.updateAllCreditInfo(false);
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                                FJUtil.eaLog('ai tool generate success', { tool: FJUtil.getToolName() });

                                isNeedUpdate = true;
                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                break;
                            case 'failed':
                                isNeedUpdate = true;
                                failTaskCount++;
                                if (failTaskCount === generatingTaskIdList.length) {
                                    isStopPolling = true;
                                }

                                //todo: 失败更新免费次数
                                FJUtil.updateAllCreditInfo(true);

                                break;
                            default:
                                break;
                        }
                    }),
                );
                if (isStopPolling) {
                    _clear();
                } else {
                    _clear();
                    f_isPolling = true;
                    f_timer = setTimeout(__pollingFunc, delayTime);
                }
                if (isNeedUpdate) {
                    dispatch(FJActionCommon.updateHistoryListAction(undefined, { ignoreLoading: true }));
                }
            } catch (error) {
                console.log(error);
                _clear();
                f_isPolling = false;
            }
        };
    },

    generateErrorAction: function (ignoreCurrentStatus = false) {
        return dispatch => {
            if (!ignoreCurrentStatus) {
                dispatch(this.setCurrentGenerateStatusAction(FJConstant.ERROR));
            }
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
        };
    },

    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            const ivFreeNum = info['image-to-video'];
            const tvFreeNum = info['text-to-video'];
            dispatch(setSliceIVFreeNumCreationAction(ivFreeNum));
            dispatch(setSliceTVFreeNumCreationAction(tvFreeNum));
        };
    },
    /**
     * 重新生成封面图
     * @param {string} id 历史记录id
     */
    regenerateCoverImageAction: function (id) {
        return async (dispatch, getState) => {
            const isOnline = await FJUtil.checkNetworkStatus();
            if (!isOnline) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                return;
            }
            const historyList = getState().common.historyList;
            const historyItem = historyList.find(item => item.id === id);
            if (!historyItem) return;
            dispatch(
                setSliceHistoryListAction(
                    historyList.map(item => {
                        if (item.id === id) {
                            return { ...item, isLoading: true };
                        }
                        return item;
                    }),
                ),
            );
            const { code, data: imageName } = await FJNetworkStore.regenerateCoverImage({
                videoUrl: historyItem.videoUrl,
                eventId: historyItem.eventId,
            });
            let videoUrl = '';
            let imgUrl = '';
            if (code == 200 && imageName) {
                videoUrl =
                    FJS3Config.S3_SERVER_HOST +
                    FJAIVideoGeneratorConfig.resultVideoKey +
                    imageName +
                    `?v=${Date.now()}`;
                imgUrl =
                    FJS3Config.S3_SERVER_HOST +
                    FJAIVideoGeneratorConfig.resultCoverKey +
                    imageName.replace('.mp4', '.png') +
                    `?v=${Date.now()}`;
            }
            dispatch(
                setSliceHistoryListAction(
                    historyList.map(item => {
                        if (item.id === id) {
                            return { ...item, isLoading: false, imgUrl, videoUrl };
                        }
                        return item;
                    }),
                ),
            );
        };
    },

    /**
     * @description 编辑AI配音
     * @param {string} id 历史记录id
     */
    editAISfxAction: function (id) {
        return async (dispatch, getState) => {
            const historyList = getState().common.historyList;
            const historyItem = historyList.find(item => item.id === id);
            if (!historyItem) return;

            FJUtil.eaLog('history preview ai sfx click');

            const data = {
                videoUrl: historyItem.videoUrl,
            };

            const __getRandomName = () => {
                // 生成随机字符串 用纯数字
                return Math.random().toString(36).substring(2, 15);
            };
            const recId = __getRandomName();

            localStorage.setItem(recId, JSON.stringify(data));
            const jumpUrl = FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-video-dub').href;
            location.href = `${jumpUrl}?rec_id=${recId}`;
        };
    },
};

export default FJActionAIVideoGenerator;
